<div class="container-md">
  <div class="mt-3 mb-3 ms-2">
    <div>
      <label class="fw-bold title" for="email">{{ 'IDS_LOGIN_WITH_MAGIC_LINK' | translate }}</label>
    </div>
    <!-- <div>
      <label class="mt-2" for="email">{{ 'IDS_EMAIL' | translate }}</label>
    </div> -->

    <form (ngSubmit)="onSubmit()" #emailForm="ngForm">
      <input
        type="email"
        id="email"
        required
        name="email"
        class="form-control my-2"
        [(ngModel)]="email"
        #emailCtrl="ngModel"
        [disabled]="sending || cooldownSeconds > 0"
        placeholder="{{ 'IDS_EMAIL' | translate }}"
      />

      @if(emailCtrl.invalid && (emailCtrl.dirty || emailCtrl.touched)){
        <div class="error mb-2">
          <label for="email">{{ 'IDS_EMAIL_NOT_VALID' | translate }}</label>
        </div>
      }

      @if(sent){
        <div class="success my-2">
          <label for="email">{{ 'IDS_MAGIC_LINK_SENT' | translate }}</label>
        </div>
      }

      <div>
        <button
          type="submit"
          class="btn-gold fw-bold px-3 text-uppercase my-2"
          [disabled]="!emailForm.form.valid || sending || cooldownSeconds > 0"
        >
          {{ sent ? ('IDS_RESEND' | translate) : ('IDS_SEND' | translate) }}
          @if(cooldownSeconds > 0){
            <span class="ms-1">({{ cooldownSeconds }}s)</span>
          }
        </button>
      </div>
    </form>

    <div class="d-flex justify-content-center mt-2">
      <button type="button" class="newAccount" (click)="backToLogin()">
        {{ 'IDS_BACK_TO_LOGIN' | translate }}
      </button>
    </div>
  </div>
</div>
